module.exports = __webpack_public_path__ + "img/Yamlive_logo.7ef73ac7.png";